import React, { useState } from 'react';
import { Tabs, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';

export const TrendsCard = () => {
  const [tab, setTab] = useState('mostViewed');
  const { t } = useTranslation();
  const tabs = [
    {
      label: t('my-organisation.trends.most-viewed-resources'),
      value: 'mostViewed',
    },
    {
      label: t('my-organisation.trends.most-searched-resources'),
      value: 'mostSearched',
    },
    {
      label: t('my-organisation.trends.recently-updated-resources'),
      value: 'recentlyUpdated',
    },
  ];

  return (
    <div className="h-full flex flex-col border-none">
      <Tabs
        tabs={tabs}
        value={tab}
        onChange={(_, value) => setTab(value)}
        className="mb-4"
      />
      <div className="flex-1 bg-[#F5FAFF]">
        {tab === 'mostViewed' && (
          <Typography variant="body2">
            Most Viewed Resources content goes here.
          </Typography>
        )}
        {tab === 'mostSearched' && (
          <Typography variant="body2">
            Most Searched Resources content goes here.
          </Typography>
        )}
        {tab === 'recentlyUpdated' && (
          <Typography variant="body2">
            Recently Uploaded or Updated Resources content goes here.
          </Typography>
        )}
      </div>
    </div>
  );
};

export default TrendsCard;
